/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { HTTP_METHOD } from "@nf/constants";
import {
  ICustomerModel,
  ILoginRequestModel,
  ILoginResponseModel,
  ILogoutRequestModel,
  IRefreshTokenRequestModel,
  IRefreshTokenResponseModel,
  ISignupRequestModel,
  ISignupResponseModel,
  ISignupVerifyRequestModel,
  ISignupVerifyResponseModel,
  IChangePasswordModel,
  IChangePasswordResponseModel,
  ILoginViaTokenRequestModel,
  IVerifyLoginCodeResponseModel,
  ILoginCodeResponseModel,
  ILoginCodeModel,
  IGetLoginTokenFromCodeModel,
} from "../models";

import { skymillHttpService } from "../../../../services";

export class AuthService {
  get url(): string {
    return "/v1";
  }

  public login = (data: ILoginRequestModel): Promise<ILoginResponseModel> =>
    skymillHttpService.request<ILoginResponseModel>({
      data,
      method: HTTP_METHOD.POST,
      url: `${this.url}/login`,
    });

  public loginViaToken = ({
    loginToken,
    ...data
  }: ILoginViaTokenRequestModel): Promise<ILoginResponseModel> =>
    skymillHttpService.request<ILoginResponseModel>({
      data,
      method: HTTP_METHOD.POST,
      url: `${this.url}/login/${loginToken}`,
    });

  public logout = (data: ILogoutRequestModel): Promise<void> =>
    skymillHttpService.request<void>({
      data,
      method: HTTP_METHOD.POST,
      url: `${this.url}/logout`,
    });

  public refreshToken = (
    data: IRefreshTokenRequestModel
  ): Promise<IRefreshTokenResponseModel> =>
    skymillHttpService.request<IRefreshTokenResponseModel>({
      data,
      method: HTTP_METHOD.POST,
      url: `${this.url}/refresh-tokens`,
    });

  public signup = (data: ISignupRequestModel): Promise<ISignupResponseModel> =>
    skymillHttpService.request<ISignupResponseModel>({
      data,
      method: HTTP_METHOD.POST,
      url: `${this.url}/signup`,
    });

  public signupVerify = (
    customerToken: string,
    data: ISignupVerifyRequestModel
  ): Promise<ISignupVerifyResponseModel> =>
    skymillHttpService.request<ISignupVerifyResponseModel>({
      data,
      method: HTTP_METHOD.POST,
      url: `${this.url}/signup/${customerToken}`,
    });

  public customer = (): Promise<ICustomerModel> =>
    skymillHttpService.request<ICustomerModel>({
      method: HTTP_METHOD.GET,
      url: `${this.url}/customer`,
    });

  public changePassword = (
    data: IChangePasswordModel
  ): Promise<IChangePasswordResponseModel> =>
    skymillHttpService.request<IChangePasswordResponseModel>({
      data,
      method: HTTP_METHOD.PATCH,
      url: `${this.url}/password`,
    });

  public getLoginCode = (): Promise<ILoginCodeResponseModel> =>
    skymillHttpService.request<ILoginCodeResponseModel>({
      method: HTTP_METHOD.GET,
      url: `${this.url}/big-screen`,
    });

  public verifyCode = (
    data: ILoginCodeModel
  ): Promise<IVerifyLoginCodeResponseModel> =>
    skymillHttpService.request<IVerifyLoginCodeResponseModel>({
      data,
      method: HTTP_METHOD.PUT,
      url: `${this.url}/big-screen`,
    });

  public getLoginTokenFromCode = (
    data: ILoginCodeModel
  ): Promise<IGetLoginTokenFromCodeModel> =>
    skymillHttpService.request<IGetLoginTokenFromCodeModel>({
      data,
      method: HTTP_METHOD.POST,
      url: `${this.url}/big-screen`,
    });
}
